import { z } from 'zod';
import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index';
import { Line1Schema } from '@Components/inputs/Line1';
import { addressStateNonUs, AddressStateSchema } from '@Components/inputs/AddressStateDropDown';
import { zipSchema, zipSchemaWNonUs } from '@Components/inputs/ZipAddress/';
import { citySchema } from '@Components/inputs/CityInput';
import type { LiliDropdownItem } from '@lili/lili-frontend-common';
import type { Country } from '@Types/country';

export const UsBusinessAddressSchema = z.object({
  ...Line1Schema.shape,
  [OnboardingFormFields.APARTMENT]: z.string().describe('apt').optional(),
  ...citySchema.shape,
  ...zipSchema.shape,
  ...AddressStateSchema.shape,

  [OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY]: z.boolean().optional().default(false),
});

export const createNonUsBuisnessAddressSchema = () =>
  z.object({
    ...Line1Schema.shape,
    [OnboardingFormFields.APARTMENT]: z.string().optional(),
    [OnboardingFormFields.COUNTRY]: z.any().refine((value) => Boolean(value), {
      error: () => t('enErrors:required'),
    }),
    ...citySchema.shape,
    ...addressStateNonUs.shape,
    ...zipSchemaWNonUs.shape,
  });
export interface IBusinessAddressForm {
  [OnboardingFormFields.LINE1]: string | null;
  [OnboardingFormFields.APARTMENT]: string | null;
  [OnboardingFormFields.CITY]: string | null;
  [OnboardingFormFields.STATE]: LiliDropdownItem | null;
  [OnboardingFormFields.ZIP]: string | null;
  [OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY]: boolean;
  [OnboardingFormFields.COUNTRY]: Country | undefined | null;
}
